export const MINIMUM_NUMBER_OF_CHARACTERS_TO_START_SEARCH = 3;
